import { useTranslation } from 'react-i18next'

import useCartItemTotal from '@features/cart/hooks/useCartItemTotal'
import { useCartStore } from '@features/cart/model/useCartStore'

import { Product } from '@shared/generated'
import { useProductUnit } from '@shared/hooks'
import { cn } from '@shared/lib/cn'
import { formatPrice } from '@shared/uttils'

import styles from './styles.module.scss'

interface PriceBlockProps {
  product: Product;
  className?: string;
  hideOldPrice?: boolean
  showTotalPriceDiscount?: boolean
}

export default function PriceBlock ({ product, hideOldPrice = false, showTotalPriceDiscount = false, className }: PriceBlockProps) {
  const { t: tc } = useTranslation('common')
  const { getProduct } = useCartStore()
  const cartItem = getProduct(product.id)
  const amount = cartItem?.amount || 0

  const totalPrice = useCartItemTotal(product, amount)
  const oldPriceTotal = useCartItemTotal(product, amount, true)

  const priceOffer = product.priceOffer
    ?? product.priceOffers?.find((offer) => offer?.isDefault)
    ?? product.priceOffers?.[0]

  const unitPrice = priceOffer?.price
  const oldPrice = priceOffer?.oldPrice

  const { unit } = useProductUnit({
    isWeightProduct: product.isWeightProduct as boolean,
    value: amount,
    price: totalPrice ?? 0,
    t: tc,
  })

  if (totalPrice == null) return null

  return (
    <div className={cn(styles.priceBlock, className)}>
      <div className={styles.priceBlock__item}>
        <div className={cn(styles.priceBlock__total, !!oldPrice && showTotalPriceDiscount ? styles['priceBlock__total--mark'] : null)}>{formatPrice(totalPrice)}</div>
        {!!oldPrice && showTotalPriceDiscount && oldPriceTotal != null && (
          <div className={styles.priceBlock__oldTotal}>{formatPrice(oldPriceTotal)}</div>
        )}
      </div>
      {!!oldPrice && !hideOldPrice && (
        <div className={styles.priceBlock__old}>
          {formatPrice(oldPrice)}
        </div>
      )}
      {unitPrice != null && (
        <div className={styles.priceBlock__unit}>
          {formatPrice(unitPrice)} / {unit}
        </div>
      )}
    </div>
  )
}
